module.exports = __webpack_public_path__ + "Montserrat-Medium.a98626e1aef6ceba5dfc.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/assets/fonts/montserrat/Montserrat-Medium.ttf
// module id = ../../../../../src/assets/fonts/montserrat/Montserrat-Medium.ttf
// module chunks = styles